import { GameScene } from "./index";
import * as ex from "excalibur";

export class AutoTurretTrait implements ex.IActorTrait {
    readonly scene: GameScene;
    lastFiredTime = -1000;
    reloadInterval = 2000;
    currentTime = 0;
    projectileSpeed = 300;
    range = 150;
    constructor(scene: GameScene) {
        this.scene = scene;
    }
    public update(actor: ex.Actor, engine: ex.Engine, delta: number) {
        this.currentTime += delta;

        let chaser = this.scene.findClosestChaser(actor.pos);
        if (chaser && chaser.pos.sub(actor.pos).magnitude() <= this.range) {
            let toChaser = chaser.pos.sub(actor.pos);
            actor.rotation = toChaser.toAngle();

            if (this.lastFiredTime + this.reloadInterval <= this.currentTime) {
                this.lastFiredTime = this.currentTime;
                let firingVector = ex.Vector.fromAngle(actor.rotation).scale(this.projectileSpeed);
                this.scene.fireProjectile(actor.pos, actor.vel.add(firingVector));
            }
        }
    }
}
